import React, { useState, useEffect, useCallback } from 'react'
import { supabase } from '../../supabase'
import ChantierChat from '../chat/ChantierChat'
// HelpWidget available if needed

// ClientDashboard : acces anonyme par code, pas de compte Supabase.
// Le chantier est recu en prop (deja charge par App.js via le code).

// ─── Layout client (sans sidebar, navigation en tabs) ─────────────────────────

// ─── Vue Apercu ───────────────────────────────────────────────────────────────

function VueApercu({ chantier, taches, onNavigate }) {
  const tachesTerminees = taches.filter(t => t.statut === 'valide' || t.statut === 'termine').length
  const tachesEnCours = taches.filter(t => t.statut === 'en_cours').length

  const etapes = [
    { id: 'planifie', label: 'Planification', icon: '📋' },
    { id: 'en_cours', label: 'Travaux en cours', icon: '🔨' },
    { id: 'termine', label: 'Reception', icon: '🎉' },
  ]
  const currentEtapeIdx = chantier.statut === 'planifie' ? 0 : chantier.statut === 'en_cours' ? 1 : 2

  return (
    <div>
      {/* Banniere progression */}
      <div style={{
        background: 'linear-gradient(135deg, #1D9E75 0%, #167a5b 100%)',
        borderRadius: 14, padding: '28px 32px', color: 'white', marginBottom: 20, position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', top: -20, right: -20, fontSize: 120, opacity: 0.08 }}>🏗️</div>
        <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6, textTransform: 'uppercase', letterSpacing: 1 }}>Mon chantier</div>
        <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6 }}>{chantier.nom}</h2>
        {chantier.adresse && <div style={{ fontSize: 14, opacity: 0.85, marginBottom: 4 }}>📍 {chantier.adresse}</div>}
        {chantier.date_fin && (
          <div style={{ fontSize: 13, opacity: 0.7 }}>
            Fin prevue : {new Date(chantier.date_fin).toLocaleDateString('fr-FR')}
          </div>
        )}
        <div style={{ marginTop: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, fontSize: 13, opacity: 0.9 }}>
            <span>Avancement global</span>
            <span style={{ fontWeight: 700, fontSize: 20 }}>{chantier.progression || 0}%</span>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.25)', borderRadius: 99, height: 12, overflow: 'hidden' }}>
            <div style={{ height: '100%', background: 'white', borderRadius: 99, width: (chantier.progression || 0) + '%', transition: 'width 0.6s ease' }} />
          </div>
        </div>
      </div>

      {/* Phases */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-header"><span className="card-title">Phases du chantier</span></div>
        <div className="card-body">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {etapes.map((etape, idx) => (
              <React.Fragment key={etape.id}>
                <div style={{
                  flex: 1, textAlign: 'center', padding: '12px 8px', borderRadius: 8,
                  background: idx <= currentEtapeIdx ? '#e8f7f2' : '#f5f6fa',
                  border: '1.5px solid ' + (idx === currentEtapeIdx ? '#1D9E75' : idx < currentEtapeIdx ? '#b8e8d8' : '#e2e8f0'),
                }}>
                  <div style={{ fontSize: 22, marginBottom: 6 }}>{etape.icon}</div>
                  <div style={{ fontSize: 12, fontWeight: idx === currentEtapeIdx ? 600 : 400, color: idx <= currentEtapeIdx ? '#1D9E75' : '#a0aec0' }}>
                    {etape.label}
                  </div>
                  {idx < currentEtapeIdx && <div style={{ fontSize: 11, color: '#1D9E75', marginTop: 2 }}>Termine</div>}
                  {idx === currentEtapeIdx && <div style={{ fontSize: 11, color: '#1D9E75', marginTop: 2 }}>En cours</div>}
                </div>
                {idx < etapes.length - 1 && (
                  <div style={{ width: 28, height: 2, background: idx < currentEtapeIdx ? '#1D9E75' : '#e2e8f0', flexShrink: 0 }} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 20 }}>
        {[
          { val: taches.length, label: 'Travaux planifies', color: 'var(--primary)', bg: 'var(--primary-light)' },
          { val: tachesEnCours, label: 'En cours', color: 'var(--info)', bg: 'var(--info-bg)' },
          { val: tachesTerminees, label: 'Realises', color: 'var(--primary)', bg: 'var(--success-bg)' },
        ].map((s, i) => (
          <div key={i} className="stat-card">
            <div style={{ fontSize: 28, fontWeight: 700, color: s.color }}>{s.val}</div>
            <div style={{ fontSize: 13, color: 'var(--gray-500)', marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {chantier.description && (
        <div className="card">
          <div className="card-header"><span className="card-title">Description du projet</span></div>
          <div className="card-body">
            <p style={{ fontSize: 14, color: 'var(--gray-600)', lineHeight: 1.7 }}>{chantier.description}</p>
          </div>
        </div>
      )}
    </div>
  )
}

// ─── Vue Avancement ───────────────────────────────────────────────────────────

function VueAvancement({ taches }) {
  const groupes = {
    valide: taches.filter(t => t.statut === 'valide'),
    termine: taches.filter(t => t.statut === 'termine'),
    en_cours: taches.filter(t => t.statut === 'en_cours'),
    en_attente: taches.filter(t => t.statut === 'en_attente'),
  }

  if (taches.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">📊</div>
        <div className="empty-state-text">Aucun travail planifie pour l instant.</div>
      </div>
    )
  }

  return (
    <div>
      <div className="section-header"><h2 className="section-title">Avancement detaille des travaux</h2></div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {[
          { key: 'valide', label: 'Travaux valides', color: '#1D9E75', bg: '#e8f7f2', icon: '✅' },
          { key: 'termine', label: 'En attente de validation', color: '#c05621', bg: '#fffbeb', icon: '🔶' },
          { key: 'en_cours', label: 'En cours de realisation', color: '#2b6cb0', bg: '#ebf8ff', icon: '🔄' },
          { key: 'en_attente', label: 'Planifies', color: '#718096', bg: '#f5f6fa', icon: '⏳' },
        ].filter(g => groupes[g.key].length > 0).map(g => (
          <div key={g.key}>
            <div style={{ fontSize: 14, fontWeight: 600, color: g.color, marginBottom: 10 }}>
              {g.icon} {g.label} ({groupes[g.key].length})
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {groupes[g.key].map(t => (
                <div key={t.id} style={{ background: g.bg, border: '1px solid ' + g.color + '30', borderRadius: 8, padding: '14px 18px' }}>
                  <div style={{ fontWeight: 500, color: 'var(--gray-800)', marginBottom: t.description ? 4 : 0 }}>{t.titre}</div>
                  {t.description && <div style={{ fontSize: 13, color: 'var(--gray-500)' }}>{t.description}</div>}
                  {t.date_echeance && <div style={{ fontSize: 12, color: g.color, marginTop: 6 }}>📅 {new Date(t.date_echeance).toLocaleDateString('fr-FR')}</div>}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

// ─── Vue Photos ───────────────────────────────────────────────────────────────

function VuePhotos({ chantierId }) {
  const [photos, setPhotos] = useState([])
  const [loading, setLoading] = useState(true)
  const [preview, setPreview] = useState(null)

  useEffect(() => {
    supabase.from('photos').select('*').eq('chantier_id', chantierId)
      .order('created_at', { ascending: false })
      .then(({ data }) => { setPhotos(data || []); setLoading(false) })
  }, [chantierId])

  if (loading) return <div className="loading-state">Chargement...</div>

  return (
    <div>
      <div className="section-header">
        <h2 className="section-title">Photos du chantier</h2>
        <span style={{ fontSize: 13, color: 'var(--gray-400)' }}>{photos.length} photo{photos.length > 1 ? 's' : ''}</span>
      </div>
      {photos.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📷</div>
          <div className="empty-state-text">Aucune photo disponible pour l instant.<br />
            <small style={{ color: 'var(--gray-400)' }}>Les entreprises ajouteront des photos au fur et a mesure.</small>
          </div>
        </div>
      ) : (
        <div className="photo-grid">
          {photos.map(p => (
            <div key={p.id} className="photo-item" onClick={() => setPreview(p)}>
              <img src={p.url} alt={p.description || 'Photo'} loading="lazy" />
              {p.description && (
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(0,0,0,0.55)', color: 'white', padding: '6px 8px', fontSize: 11 }}>
                  {p.description}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {preview && (
        <div className="modal-overlay" onClick={() => setPreview(null)}>
          <div style={{ maxWidth: 800, width: '100%', background: 'white', borderRadius: 14, overflow: 'hidden' }}>
            <img src={preview.url} alt={preview.description} style={{ width: '100%', display: 'block' }} />
            <div style={{ padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500 }}>{preview.description || 'Photo du chantier'}</div>
                {preview.created_at && <div style={{ fontSize: 12, color: 'var(--gray-400)' }}>{new Date(preview.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</div>}
              </div>
              <button className="btn btn-outline btn-sm" onClick={() => setPreview(null)}>Fermer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// ─── Vue Documents ────────────────────────────────────────────────────────────

function VueDocuments({ chantierId }) {
  const [documents, setDocuments] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.from('documents').select('*').eq('chantier_id', chantierId)
      .order('created_at', { ascending: false })
      .then(({ data }) => { setDocuments(data || []); setLoading(false) })
  }, [chantierId])

  if (loading) return <div className="loading-state">Chargement...</div>

  return (
    <div>
      <div className="section-header"><h2 className="section-title">Documents du chantier</h2></div>
      {documents.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📄</div>
          <div className="empty-state-text">Aucun document partage pour l instant.</div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16 }}>
          {documents.map(doc => (
            <a key={doc.id} href={doc.url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
              <div className="card" style={{ padding: 20, cursor: 'pointer', transition: 'border-color 0.15s' }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>
                  {doc.type && doc.type.includes('pdf') ? '📕' : doc.type && doc.type.includes('image') ? '🖼️' : '📄'}
                </div>
                <div style={{ fontWeight: 500, fontSize: 14, color: 'var(--gray-800)', marginBottom: 4 }}>{doc.nom}</div>
                <div style={{ fontSize: 12, color: 'var(--gray-400)', marginBottom: 10 }}>
                  {doc.created_at ? new Date(doc.created_at).toLocaleDateString('fr-FR') : ''}
                </div>
                <div style={{ fontSize: 12, color: '#1D9E75', fontWeight: 500 }}>Telecharger</div>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  )
}

// ─── Composant Principal Client ───────────────────────────────────────────────

export default function ClientDashboard({ chantier, onQuitter }) {
  const [activePage, setActivePage] = useState('apercu')
  const [taches, setTaches] = useState([])

  const loadTaches = useCallback(async () => {
    const { data } = await supabase
      .from('taches')
      .select('*')
      .eq('chantier_id', chantier.id)
      .order('created_at', { ascending: true })
    setTaches(data || [])
  }, [chantier.id])

  useEffect(() => { loadTaches() }, [loadTaches])

  const TABS = [
    { id: 'apercu', label: 'Apercu', icon: '🏠' },
    { id: 'avancement', label: 'Avancement', icon: '📊' },
    { id: 'photos', label: 'Photos', icon: '📷' },
    { id: 'documents', label: 'Documents', icon: '📄' },
    { id: 'messages', label: 'Messages', icon: '💬' },
  ]

  const renderPage = () => {
    switch (activePage) {
      case 'apercu': return <VueApercu chantier={chantier} taches={taches} onNavigate={setActivePage} />
      case 'avancement': return <VueAvancement taches={taches} />
      case 'photos': return <VuePhotos chantierId={chantier.id} />
      case 'documents': return <VueDocuments chantierId={chantier.id} />
      case 'messages': return (
        <div style={{ background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', height: 'calc(100vh - 200px)', minHeight: 400, display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #e2e8f0', fontWeight: 600, fontSize: 14, color: '#2d3748', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>{'💬'}</span> Discussion avec votre architecte
          </div>
          <div style={{ fontSize: 11, color: '#276749', padding: '5px 20px', background: '#f0fff4', borderBottom: '1px solid #c6f6d5', flexShrink: 0 }}>
            Canal prive entre vous et votre architecte
          </div>
          <ChantierChat
            chantierId={chantier.id}
            canal="client"
            currentUserId={null}
            currentUserNom={'Client ' + (chantier.code || '')}
          />
        </div>
      )
      default: return <VueApercu chantier={chantier} taches={taches} onNavigate={setActivePage} />
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--gray-100)', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <header style={{
        background: 'white', borderBottom: '1px solid var(--gray-200)',
        padding: '0 24px', height: 60, display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100,
        boxShadow: 'var(--shadow-sm)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{
            width: 34, height: 34, background: '#1D9E75', borderRadius: 8,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'white', fontWeight: 700, fontSize: 16, flexShrink: 0,
          }}>C</div>
          <div style={{ width: 1, height: 28, background: 'var(--gray-200)' }} />
          <div>
            <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--gray-800)' }}>{chantier.nom}</div>
            <div style={{ fontSize: 11, color: 'var(--gray-400)' }}>Suivi client en lecture</div>
          </div>
        </div>
        <button
          onClick={onQuitter}
          style={{
            background: 'none', border: '1.5px solid var(--gray-200)', borderRadius: 8,
            padding: '6px 14px', fontSize: 13, color: 'var(--gray-500)', cursor: 'pointer',
          }}
        >
          Changer de chantier
        </button>
      </header>

      {/* Tabs */}
      <div style={{ background: 'white', borderBottom: '1px solid var(--gray-200)', padding: '0 24px', display: 'flex' }}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActivePage(tab.id)}
            style={{
              padding: '14px 18px', border: 'none', background: 'none', cursor: 'pointer',
              fontSize: 13, fontWeight: activePage === tab.id ? 600 : 400,
              color: activePage === tab.id ? '#1D9E75' : 'var(--gray-500)',
              borderBottom: activePage === tab.id ? '2px solid #1D9E75' : '2px solid transparent',
              display: 'flex', alignItems: 'center', gap: 6,
            }}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      {/* Contenu */}
      <main style={{ flex: 1, padding: '28px 24px', maxWidth: 960, width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>
        {renderPage()}
      </main>
    </div>
  )
}
